// extracted by css-extract-rspack-plugin
export default {"form":"IPkMZ2xSWSEItpMj"};